export const categories = [
  { slug: "yulequan", name: "娱乐圈", icon: "ri-movie-line", desc: "娱乐圈最新爆料，明星八卦一网打尽" },
  { slug: "wanghong", name: "网红爆料", icon: "ri-live-line", desc: "网红圈内幕揭秘，直播带货黑料" },
  { slug: "mingxing", name: "明星黑料", icon: "ri-star-line", desc: "明星不为人知的另一面深度挖掘" },
  { slug: "shehui", name: "社会热点", icon: "ri-fire-line", desc: "社会热点事件深度追踪报道" },
  { slug: "tiyu", name: "体育圈", icon: "ri-basketball-line", desc: "体育圈内幕与运动员私生活爆料" },
  { slug: "caijing", name: "财经内幕", icon: "ri-funds-line", desc: "财经圈资本运作与商业内幕揭秘" },
];

export const categoryMap: Record<string, string> = {
  yulequan: "娱乐圈",
  wanghong: "网红爆料",
  mingxing: "明星黑料",
  shehui: "社会热点",
  tiyu: "体育圈",
  caijing: "财经内幕",
};